module.exports = __webpack_public_path__ + "static/media/md-american-football.9667d250.svg";